import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconCanStyle0 = cosmosIconCss;

const CosmosIconCan$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCan extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '3e49c4ae2f55c127463ae2867d3a8f7502f540bd', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '8692eba721d53456ef98e46db7af593dc607efbd', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '1d73dc338d5470e81e4050946f4a768e0ebcedee', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16 5c0-1.778-1.977-3-4.5-3C8.977 2 7 3.222 7 5v11.644C7 18.19 9.264 19 11.5 19s4.5-.81 4.5-2.356V5Zm-4.5-1.5c1.654 0 3 .673 3 1.5 0 .627-1.141 1.5-3 1.5s-3-.873-3-1.5c0-.827 1.346-1.5 3-1.5Zm-3 13.144v-4.93a5.43 5.43 0 0 0 2.94.8l1.911-4.777a5.022 5.022 0 0 0 1.149-.5v4.494a5.477 5.477 0 0 1-3 .8h-.052l-1.882 4.7c-.647-.195-1.019-.453-1.066-.587Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconCanStyle0; }
}, [1, "cosmos-icon-can", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-can"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-can":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCan$1);
            }
            break;
    } });
}

const CosmosIconCan = CosmosIconCan$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCan, defineCustomElement };
